/* eslint-disable @typescript-eslint/no-explicit-any */
import { StatementLineItemPayment } from "@/types/payments";
import { create } from "zustand";

interface IFormData {
  formData: { [key: string]: string };
  formDataSecondTab: { [key: string]: string };
  setFormData: (data: { [key: string]: string }) => void;
  setStepAndFormDataSecondTab: (step: number, data: { [key: string]: string }) => void;
  step: number;
  isInvoice: boolean;
  setStep: (step: number) => void;
  setStepAndFormData: (step: number, data: { [key: string]: string }) => void;
  resetForm: () => void;
  setIsInvoice: (invoice: boolean) => void;
  customerInvoiceResponse: any;
  setCustomerInvoiceResponse: (data: any) => void;
  resetFormDataSecondTab: () => void;
  paymentSuccessResponse: any;
  setPaymentSuccessResponse: (data: any) => void;
  enteredEmail: string;
  setEnteredEmail: (email: string) => void;
  guestType: number;
  setGuestType: (type: number) => void;
  userType: boolean;
  setUserType: (type: boolean) => void;
  addedInvoice: any;
  setAddedInvoice: (data: { [key: string]: string }) => void;
  selectedInvoicesResponse: StatementLineItemPayment[];
  setSelectedInvoicesResponse: (data: StatementLineItemPayment[]) => void;
  partialPaymentSuccess: boolean;
  setPartialPaymentSuccess: (value: boolean) => void;
  portalAccountCreation: boolean;
  setPortalAccountCreation: (value: boolean) => void;
  showMsgForMissingInvoices: boolean;
  setShowMsgForMissingInvoices: (value: boolean) => void;
}

export const usePayAnInvoiceFormData = create<IFormData>((set) => ({
  partialPaymentSuccess: false,
  portalAccountCreation: false,
  step: 1,
  formData: {},
  formDataSecondTab: {},
  isInvoice: true,
  enteredEmail: "",
  guestType: 0,
  userType: false,
  customerInvoiceResponse: {},
  showMsgForMissingInvoices: false,
  setShowMsgForMissingInvoices: (data: boolean) => set(() => ({ showMsgForMissingInvoices: data })),
  setCustomerInvoiceResponse: (data: any) => set(() => ({ customerInvoiceResponse: data })),
  paymentSuccessResponse: {},
  setPaymentSuccessResponse: (data: any) => set(() => ({ paymentSuccessResponse: data })),

  setFormData: (data: { [key: string]: string }) => set((state) => ({ formData: { ...state.formData, ...data } })),
  setStepAndFormDataSecondTab: (step: number, data: { [key: string]: string }) =>
    set((state) => {
      return { step: step, formDataSecondTab: { ...state.formDataSecondTab, ...data } };
    }),
  setStep: (step: number) => set(() => ({ step: step })),
  setIsInvoice: (invoice: boolean) => set(() => ({ isInvoice: invoice })),
  setStepAndFormData: (step: number, data: { [key: string]: string }) =>
    set((state) => {
      return { step: step, formData: { ...state.formData, ...data } };
    }),
  setGuestType: (type: number) => set(() => ({ guestType: type })),
  setUserType: (usertype: boolean) => set(() => ({ userType: usertype })),
  setEnteredEmail: (email: string) => set(() => ({ enteredEmail: email })),
  resetForm: () =>
    set(() => ({
      formData: {},
      formDataSecondTab: {},
      step: 1,
      addedInvoice: [],
      partialPaymentSuccess: false,
      portalAccountCreation: false,
      showMsgForMissingInvoices: false,
    })),
  resetFormDataSecondTab: () => set(() => ({ formDataSecondTab: {} })),
  addedInvoice: [],
  setAddedInvoice: (data: any) => set(() => ({ addedInvoice: data })),

  selectedInvoicesResponse: [],
  setSelectedInvoicesResponse: (data: StatementLineItemPayment[]) => set(() => ({ selectedInvoicesResponse: data })),
  setPartialPaymentSuccess: (value) => set(() => ({ partialPaymentSuccess: value })),
  setPortalAccountCreation: (value) => set(() => ({ portalAccountCreation: value })),
}));
